import {
    Routes,
    Route,
} from "react-router-dom";
import React, { lazy, Suspense } from "react";
import Loader from "../components/Loader";


// Lazy load components
const NotFound = lazy(() => import("../components/NotFound"));
const LoginScreen = lazy(() => import("../pages/NotAuthenticated/LoginPage"));
const ForgotPassword = lazy(() => import("../pages/NotAuthenticated/ForgotPassword"));


const NotAuthenticationRoute = () => {


    return (
        
            <Suspense fallback={<Loader open={true}/>}>
                <Routes>
                    <Route path="/" element={<LoginScreen />} />
                    <Route path="/login" element={<LoginScreen />} />
                    <Route path="/forgotpwd" element={<ForgotPassword />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Suspense>
       
    )
}

export default React.memo(NotAuthenticationRoute);